import { render, staticRenderFns } from "./register-team.vue?vue&type=template&id=213535fb&"
import script from "./register-team.vue?vue&type=script&lang=js&"
export * from "./register-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports